import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  typeBlock: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '18px',
    '& .MuiToggleButtonGroup-root': {
      marginRight: '10px'
    }
  },
  datePicker: {
    display: 'inline-block',
    width: '200px'
  },
  smallField: {
    width: '200px'
  },
  titleField: {
    width: '100%'
  },
  modalFooter: {
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  footerEven: {
    display: 'flex',
    justifyContent: 'space-between',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse'
    }
  },
  footerWrapper: {
    display: 'flex',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& + &': {
        marginBottom: '10px'
      }
    }
  },
  notificationCheckbox: {
    marginTop: '24px',
    borderTop: "1px solid ".concat(palette.shades[300]),
    paddingTop: '24px'
  },
  title: {
    '&::first-letter': {
      textTransform: 'uppercase'
    }
  },
  counter: {
    textAlign: 'right',
    fontSize: '12px',
    color: palette.shades[700]
  },
  counterError: {
    position: 'relative',
    top: '-22px'
  },
  chargeCreditTypeHeader: {
    backgroundColor: palette.shades[200],
    lineHeight: '14px',
    fontSize: '14px',
    padding: '8px 12px 6px',
    '&:hover': {
      backgroundColor: palette.shades[200],
      cursor: 'default'
    }
  },
  chargeCreditType: {
    padding: '12px 16px 12px 12px',
    '& .MuiSvgIcon-root': {
      marginRight: '8px',
      backgroundColor: palette.shades[200],
      padding: '2px',
      fontSize: '24px'
    }
  }
}));
export default useStyles;